<!--

<p>
 Loading...
</p>

<app-modal-option [modalConfig]="alertModalConfig" *ngIf="displayAlert" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()" (secondaryBtnClick)="alertSecondaryBtnClick()" ></app-modal-option>
-->
<div *ngIf="CMSData && displayAlert && loginResponse['gcdcustomer']" class="modal-wrapper background-grey">
    <div class="modal">
        <div class="modal-header border-none">
            <h4 class="modal-title " tabindex="0" #closeBtnHeader [id]="mismatch-header">{{CMSData.string_RegistrationDetailsDifferTitle}}</h4>
            <button class="margin-25" id="btn-close-modal reflect " #closeBtn tabindex="-1" type="button" (click)="closeModal()">
                <span class="icon icon-cross reflect" tabindex="0" aria-hidden="true"></span>
                <span class="access" id="text-close-modal">Close modal
                </span>
            </button>
        </div>
        <div class="table-wrapper margin-top">
            <table class="table" *ngIf="loginResponse['customer']">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">{{CMSData.string_RegistrationDetailsDifferReg}}</th>
                        <th scope="col">{{CMSData.string_RegistrationDetailsDifferQuote}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <!--<td>forename</td> -->
                        <th scope="row">First name</th>
                        <td>{{loginResponse['gcdcustomer'].forename}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer'].forename !=loginResponse['gcdcustomer'].forename:false}">{{loginResponse['customer'].forename? loginResponse['customer'].forename :''}}</td>

                    </tr>
                    <tr>
                        <!--<td>middlename</td> -->
                        <th scope="row">Second name</th>
                        <td>{{loginResponse['gcdcustomer'].middleName}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer'].middleName !=loginResponse['gcdcustomer'].middleName:false}">{{loginResponse['customer'].middleName? loginResponse['customer'].middleName :''}}</td>

                    </tr>
                    <tr>
                        <!--<td>surname</td> -->
                        <th scope="row">Surname</th>
                        <td>{{loginResponse['gcdcustomer'].surname}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer'].surname !=loginResponse['gcdcustomer'].surname:false}">{{loginResponse['customer'].surname? loginResponse['customer'].surname :''}}</td>

                    </tr>
                    <tr>
                        <!--<td>thirdname</td> -->
                        <th scope="row">Third name</th>
                        <td>{{loginResponse['gcdcustomer'].thirdName}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer'].thirdName !=loginResponse['gcdcustomer'].thirdName:false}">{{loginResponse['customer'].thirdName? loginResponse['customer'].thirdName :''}}</td>

                    </tr>
                    <tr>
                        <!--<td>Date of birth</td> -->
                        <th scope="row">Date of birth</th>
                        <td>{{loginResponse['gcdcustomer'].dateOfBirth}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer'].dateOfBirth !=loginResponse['gcdcustomer'].dateOfBirth:false}">{{loginResponse['customer'].dateOfBirth? loginResponse['customer'].dateOfBirth :''}}</td>

                    </tr>
                    <tr>
                        <!--<td>Gender</td>-->
                        <th scope="row">Gender</th>
                        <td>{{loginResponse['gcdcustomer'].gender}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer'].gender !=loginResponse['gcdcustomer'].gender:false}">{{loginResponse['customer'].gender}}</td>

                    </tr>
                    <tr>
                        <!--<td>Marital status</td> -->
                        <th scope="row">Marital status</th>
                        <td>{{loginResponse['gcdcustomer'].maritalStatus}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer'].maritalStatus !=loginResponse['gcdcustomer'].maritalStatus:false}">{{loginResponse['customer'].maritalStatus}}</td>

                    </tr>
                    <tr>
                        <!--<td>Address Line 1</td>  -->
                        <th scope="row">Address line 1</th>
                        <td>{{loginResponse['gcdcustomer']['address'].line1}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer']['address']?.line1 !=loginResponse['gcdcustomer']['address']?.line1:false}">{{loginResponse['customer']['address']?.line1}}</td>

                    </tr>
                    <tr>
                        <!--<td>Address Line 2</td>  -->
                        <th scope="row">Address line 2</th>
                        <td>{{loginResponse['gcdcustomer']['address'].line2}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer']['address']?.line2 !=loginResponse['gcdcustomer']['address']?.line2:false}">{{loginResponse['customer']['address']?.line2}}</td>

                    </tr>
                    <tr>
                        <!--<td>Address Line 3</td>  -->
                        <th scope="row">Address line 3</th>
                        <td>{{loginResponse['gcdcustomer']['address'].line3}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer']['address']?.line3 !=loginResponse['gcdcustomer']['address']?.line3:false}">{{loginResponse['customer']['address']?.line3}}</td>

                    </tr>
                    <tr>
                        <!--<td>Address Line 4</td>  -->
                        <th scope="row">Address line 4</th>
                        <td>{{loginResponse['gcdcustomer']['address'].line4}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer']['address']?.line4 !=loginResponse['gcdcustomer']['address']?.line4:false}">{{loginResponse['customer']['address']?.line4}}</td>

                    </tr>
                    <tr>
                        <!--<td>Postcode </td>  -->
                        <th scope="row">Postcode </th>
                        <td>{{loginResponse['gcdcustomer']['address'].postcode}}</td>
                        <td [ngClass]="{'color-red':loginResponse?loginResponse['customer']['address']?.postcode !=loginResponse['gcdcustomer']['address']?.postcode:false}">{{loginResponse['customer']['address']?.postcode}}</td>

                    </tr>

                </tbody>
            </table>
        </div>
        <div>
            <div class="clear-all" style="display: flex;" #samePrdctBtn tabindex="0">
                <button id="btnYes" style="margin-top: 2rem" (click)="alertPrimaryBtnClick()" class="btn btn-cta btn-block reflect-btn" type="button">{{CMSData.string_RegistrationDetailsDifferContinueCTALabel}}</button>
            </div>
            <div class="center-align" style="display: flex;">{{CMSData.stringGroup_RegistrationDetailsDifferRegIncorrect}}</div>
        </div>
    </div>
</div>